'use strict';

var _regeneratorRuntime = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var DAGLink = require('../dag-link/dagLink');

var genCid = require('../genCid');
/*
 * toDAGLink converts a DAGNode to a DAGLink
 */


var toDAGLink =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(node) {
    var options,
        nodeCid,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            _context.next = 3;
            return genCid.cid(node.serialize(), options);

          case 3:
            nodeCid = _context.sent;
            return _context.abrupt("return", new DAGLink(options.name || '', node.size, nodeCid));

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function toDAGLink(_x) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = toDAGLink;